import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';

import { getBillList, selectListLoading, selectBillList } from './billSlice';
import { Typography } from '../../components/Typography';
import { Spacer } from '../../components/Spacer';
import { ModalLinkButton } from '../../components/ModalLinkButton';
import ThumbnailGallery from '../../components/Common/ThumbnailGallery';
import HelpBox from '../../components/Common/HelpBox';
import { BillTable } from './BillTable';

export function BillList(): JSX.Element {
  const dispatch = useDispatch();
  const getBillListAction = useCallback(() => dispatch(getBillList()), [dispatch]);

  const billList = useSelector(selectBillList);
  const listLoading = useSelector(selectListLoading);

  useEffect(() => {
    getBillListAction();
  }, [getBillListAction]);

  if (listLoading) {
    return <Spinner animation="border" />;
  }

  return (
    <Row>
      <Col>
        <Typography variant="h3">INFORMATION</Typography>
        <Spacer variant="small" />

        <div className="d-flex align-items-center">
          <Typography variant="h1">Bills</Typography>
          <HelpBox
            placement="right"
            content={
              <>
                <ul className="mb-0">
                  <li>Add the details of all your recurring and one-off Bills or upcoming payments here.​</li>
                  <br />
                  <li>Fairly open-ended format, designed to cover all types of payment obligations.​</li>
                  <br />
                  <li>You will be reminded through your Alerts, Emails and Texts depending on the urgency. </li>
                </ul>
              </>
            }
          >
            {' '}
            <ModalLinkButton to="/expense/bill/add" className="ml-3">
              Add
            </ModalLinkButton>
          </HelpBox>
        </div>

        <BillTable billList={billList} />

        <Spacer variant="red-spacer" />

        <Typography variant="h3">KNOWLEDGE</Typography>
        <Spacer variant="small" />
        <Typography variant="h1">Managing Bills</Typography>
        <Spacer variant="large" />
        <ThumbnailGallery apiUrl="sections/bills/categories/" />
      </Col>
    </Row>
  );
}
